"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _intl = require("@kyruus/intl");
var _propTypes = require("prop-types");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _button = _interopRequireDefault(require("@kyruus/button"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Popover = _ref => {
  let {
    buttonRef,
    dataTestId,
    direction,
    onClose,
    children,
    intl
  } = _ref;
  const handleClickOutside = _ref2 => {
    let {
      target
    } = _ref2;
    if (buttonRef.current.contains(target) === false) onClose();
  };
  const handleCloseKey = _ref3 => {
    let {
      key
    } = _ref3;
    if (key === 'Escape') onClose();
  };
  (0, _react.useEffect)(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleCloseKey);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleCloseKey);
    };
  });
  return /*#__PURE__*/_react.default.createElement(_styles.CustomPaper, {
    className: direction,
    elevation: 4,
    "data-testid": dataTestId
  }, children, /*#__PURE__*/_react.default.createElement(_styles.CancelButtonContainer, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: onClose,
    "aria-label": intl.formatMessage(_messages.default.ariaJumpToDateFilterCloseButton),
    "data-testid": `${dataTestId}-close`
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptTimeFilterCloseBtn))));
};
Popover.propTypes = {
  dataTestId: _propTypes.string,
  direction: (0, _propTypes.oneOf)(['right', 'left']),
  onClose: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired,
  buttonRef: (0, _propTypes.shape)({
    current: _react.Element
  }).isRequired,
  intl: (0, _propTypes.shape)({
    formatMessage: _propTypes.func.isRequired
  }).isRequired
};
var _default = exports.default = (0, _intl.injectIntl)(Popover);
Popover.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Popover",
  "props": {
    "dataTestId": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "direction": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }]
      },
      "required": false
    },
    "onClose": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "buttonRef": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "custom",
            "raw": "Element",
            "required": false
          }
        }
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};